<template>
    <div style="padding:1px;">
      <hd></hd>
      <div class="snatched">
          <img :src="keywordqrcode" style="border:1px solid;padding:5px 0"/>
          <vue-canvas-poster :widthPixels="0" :painting="painting" @success="success" @fail="fail"></vue-canvas-poster>
      </div>
      <ft class="ft"></ft>
    </div>
</template>
<script>
import hd from '../../components/Header'
import ft from '../../components/Footer'
import Loading from '../../components/Loading'
import mobilefooter from '../../components/mobilefooter'
import api from '../../services/api.js'

export default {
  name: 'SearchCode',
  components: {
    hd: hd,
    mobilefooter: mobilefooter,
    ft: ft,
    Loading: Loading
  },
  data () {
    return {
      keyword:'',
      keywordqrcode:'',
      painting:{},
      searchpainting:{
        width:`250px`,
        height:`350px`,
        background: '#fff',
        views: [
          {
            type: 'text',
            text: 'JoyOrders微信小程序',
            css: {
              top:'125px',
              left:'25px',
              color:'#000',
              fontSize: '20px',
              textAlign:'left',
              padding:'10px'
            }
          },
          {
            type: 'rect',
            css: 
              {
                //paintingWidth:250,
                top:'250px',
                color:'#444',
                width:'250px',
                height:'25px'
              }
            
          },
          {
            type: 'text',
            text: '长按识别，查看搜索 >',
            css: 
              {
                //paintingWidth:250,
                top:'255px',
                color:'#fff',
                fontSize: '13px',
                textAlign:'left',
                padding:'10px'
              }
            
          },
          {
            type: 'rect',
            css: {
              width:`100px`,
              height:`100px`,
              color:'#fff',
              borderRadius:'50px',
              right:'2px',
              top: '210px'
            }
          },
          {
            type: 'image',
            url: '',
            css: {
              width:`90px`,
              height:`90px`,
              right:'7px',
              top: '215px'
            }
          },
          {
            type: 'text',
            text: '',
            css: 
              {
                top:'310px',
                color:'#444',
                fontSize: '14px',
                textAlign:'left',
                padding:'10px',
                maxLines:'2',
                width: '230px',
                lineHeight: '20px',
              }
          },
        ],
      },
    }
  },
  mounted () {
    this.keyword=this.$route.query.q?this.$route.query.q:0
    if(this.keyword)
      this.generateCode()
  },
  methods: {
    fail(err) {
      console.log('fail', err)
    },
    success(src) {
     this.keywordqrcode=src;
    },
    generateCode(){
      let params={}
      params={
						page: 'pages/search/category',
						is_hyaline: true,
						scene: encodeURIComponent(this.keyword).replace(/%/g,';')
					}
          api.post(this, {
              path: 'good.php',
              data: params,
              loading: 'loading',
              api: 'create_qr_code'
          }).then((res)=>{
            this.$set(this.searchpainting.views[4], 'url', res.body);
            this.$set(this.searchpainting.views[5], 'text', `查看‘${this.keyword}’的搜索结果`);
            this.painting=JSON.parse(JSON.stringify(this.searchpainting))
          })
    },
  },
}

</script>
<style scoped lang="scss">
.snatched {
    margin: 0 auto 60px;;
    margin-top: 180px;
    // width: 914px;
    padding: 0 20%;
    text-align: center;
}
    @media screen and (max-width:1375px){
        .snatched {
            padding: 0 15%;
        }
    }
    @media screen and (max-width:1200px){
        .snatched {
            padding: 0 10%;
        }
    }
    @media screen and (max-width:1025px){
        .snatched {
            padding: 0 10px;
            margin-top: 100px;
            .toggleList {
                padding-left: 0 !important;

                .toggle{

                    width: 100%;
                    margin-bottom: 20px;
                }
            }

            .button {
                float: left;
            }

            .pool {
                margin-top: 20px;
                .poolTitle {
                    display: block;
                    width: 250px !important;
                    font-size: 14px;
                }
            }
        }
    }
    @media screen and (max-width:750px){
        .snatched {
            .pool {

                .goods  {

                    .left-content {
                        width: 100%;
                        margin-bottom: 20px;

                        .goodsList {

                            .order-des {
                                float: right !important;
                                width: 50% !important;
                            }
                        }
                    }

                    .right-operation {
                        .mobile-button {
                            width: 268px !important;
                        }
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/qrcode/searchCode.vue